import { ReactNode } from 'react';
import { Box, Button, SIZE, Stack, Text } from '@quinyx/ui';

import { EMPTY_VALUE } from '@/constants/support-task';
import { useTranslate } from '../../hooks/translate';

type TaskFieldProps = {
  label: string;
  children: ReactNode;
};

export const TaskField = ({ label, children }: TaskFieldProps) => (
  <Stack spacing={SIZE.XS}>
    <Text variant="smallRegular" color="SurfaceOnSurfaceAlt">
      {label}
    </Text>
    <Text as="div" variant="bodyRegular">
      {children}
    </Text>
  </Stack>
);

export const CodeValue = ({ children }: { children: ReactNode }) => (
  <Box
    as="span"
    backgroundColor="SurfaceContrastLow"
    border
    borderRadius="s"
    px={SIZE.XS}>
    {children}
  </Box>
);

type CopyableValueProps = {
  value?: string;
  testId: string;
};

export const CopyableValue = ({ value, testId }: CopyableValueProps) => {
  const { t } = useTranslate();
  if (!value) {
    return <>{EMPTY_VALUE}</>;
  }
  return (
    <Stack direction="row" alignItems="center" spacing={SIZE.XS}>
      <CodeValue>{value}</CodeValue>
      <Button
        data-test-id={testId}
        aria-label={t('common.copy')}
        icon="copy"
        variant="text"
        size={SIZE.S}
        onClick={() => navigator.clipboard.writeText(value)}
      />
    </Stack>
  );
};
